import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { clearUploadState } from "../store/slices/fileSlice";
import { uploadFileThunk } from "../store/slices/fileSlice";


const useFileUpload = (form, dispatch) => {
  const { loading } = useSelector((state) => state.file);
  const handleFileUpload = async (info) => {
    // console.log("handleFileUpload info>>>>>>>>>>", info);
    if (loading) {
      toast.warn("An upload is already in progress — please wait.");
      return;
    }
    const fileObj = info?.file?.originFileObj || info?.file;
    // console.log("fileObj>>>>>>>>>>>>>>>>>>>>>>>>>", fileObj);
    if (!fileObj) return;

    // Clear previous upload/process errors immediately on new selection
    dispatch(clearUploadState());

    if (!form.getFieldValue("fileName") && info?.file?.name) {
      form.setFieldsValue({ fileName: info.file.name });
    }

    const values = form.getFieldsValue();

    // console.log("Uploading with values:", {
    //   file: fileObj,
    //   processName: values.processName || "",
    //   subProcess: values.subProcess || "",
    //   fileName: values.fileName || fileObj.name,
    // });

    const result = await dispatch(
      uploadFileThunk({
        file: fileObj,
        processName: values.processName || "",
        subProcess: values.subProcess || "",
        fileName: values.fileName || fileObj.name,
      })
    );

    if (uploadFileThunk.fulfilled.match(result)) {
      // console.log("Upload result payload:", result.payload);

      const fp =
        result.payload?.file_path ||
        result.payload?.filePath ||
        result.payload?.data?.file_path ||
        result.payload?.data?.filePath;

      if (fp) {
        toast.success("File uploaded. Ready to submit.");
      } else {
        toast.warn("Uploaded, but file path missing in response.");
        // console.log("Full response:", result.payload);
      }
    } else {
      console.error("Upload failed:", result.payload);
      toast.error(result.payload || "Upload failed!");
    }
  };

  return { handleFileUpload };
};

export default useFileUpload;
